import api from './api';

export const statsApi = {
  get: () => api.get('/api/stats'),
  team: () => api.get('/api/stats/team'),
};
